import styled from 'styled-components'

export const RankmiTableWrapper = styled.div`
  && .ant-row {
    margin-bottom: 0 !important;
  }

  .rankmiTable-table {
    margin-top: 0;
  }
`
